import { MyProfileActions } from '../actions';
import { createReducer, on } from '@ngrx/store';

//Request Access Button
export interface State {
    requestAccess: boolean;
}

export const initialButtonState: State = {
    requestAccess: false,
};

export const myReducer = createReducer(
    initialButtonState,
    on(MyProfileActions.buttonClickRequestAccess, (state: State) => ({
        ...state,
        requestAccess: !state.requestAccess,
    }))
);